import { html, TemplateResult } from 'lit';
import { OutlineCard } from '../../base/outline-card/outline-card';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-highlights-card.css.lit';

/**The IDB card component.
 * @element idb-highlights-card
 * @slot heading slot - the title portion of the header
 * @slot info slot - The info portion of the slot.
 */

@customElement('idb-highlights-card')
export class HighlightsCard extends OutlineCard {
  static styles = [componentStyles];

  render(): TemplateResult {
    return html`
      <section class="idb-highlights-card">
        <div class="inner">
          ${this._conditionalSlotTemplate({
            slotName: 'heading',
          })}

          ${this._conditionalSlotTemplate({
            slotName: 'info',
          })}
        </div>
      </section>
    `;
  }
}
